import { useEffect } from 'react';

/**
 * Injects a JSON-LD <script> into <head> for as long as the calling
 * component is mounted, removing it on unmount/data change. Pass
 * `undefined` to skip (e.g. while a post is still loading).
 */
export function useJsonLd(data: Record<string, unknown> | undefined) {
  useEffect(() => {
    if (!data) return undefined;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [data]);
}
